// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"714":"875c64c8","921":"875c64c8","1205":"875c64c8","4506":"875c64c8"}[chunkId] + ".chunk.css";
};